export enum AssignmentTypeEnum {
  CERTIFICATION = 'CERTIFICATION',
  PRACTICE = 'PRACTICE',
  PERSONALIZED_PRACTICE = 'PERSONALIZED_PRACTICE',
  PATHWAY = 'PATHWAY',
}

export enum EntityType {
  SIMULATION = 'simulation',
  ASSIGNMENT = 'assignment',
  NON_STAGED_ASSIGNMENT = 'non_staged_assignment',
}

export enum EntityActionType {
  CREATE = 'create',
  DUPLICATE = 'duplicate',
}


export enum AssignmentStatusLabelEnum {
  DRAFT = 'Draft',
  STAGED = 'Staged',
  ACTIVE = 'Active',
  COMPLETE = 'Complete',
  CLOSED = 'Closed',
  ARCHIVED = 'Archived',
}

export enum AssignmentStatusValueEnum {
  DRAFT = 'draft',
  STAGED = 'staged',
  ACTIVE = 'active',
  COMPLETE = 'complete',
  CLOSED = 'closed',
  ARCHIVED = 'archived',
}


